import PropTypes from "prop-types";

import { alignItems } from "../../../../../../consts";
import { t } from "../../../../../../services";

import { FlexContainers, WrapperContainer } from "../../../../../../components";
import { Title } from "./styled";

export const InfoTemplate = ({ title, children }) => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={4}
      width={"100%"}>
      <Title>{t(title)}</Title>

      {children}
    </WrapperContainer>
  );
};

InfoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
